export class TemporaryReportDownload {
    Viewing!: boolean;

    constructor(initializer: TemporaryReportDownload) {
        Object.assign(this, initializer);
    }
}

export type TemporaryReportDownloads = Record<string, TemporaryReportDownload>;

export enum TemporaryReportDownloadStatus {
    Processing = "Processing",
    Ready = "Ready"

}
